/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Table_Actions_HeaderInputs */

const en_speakers_table_actions_header = /** @type {(inputs: Speakers_Table_Actions_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions`)
};

const fr_speakers_table_actions_header = /** @type {(inputs: Speakers_Table_Actions_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions`)
};

const de_speakers_table_actions_header = /** @type {(inputs: Speakers_Table_Actions_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktionen`)
};

const it_speakers_table_actions_header = /** @type {(inputs: Speakers_Table_Actions_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azioni`)
};

const ru_speakers_table_actions_header = /** @type {(inputs: Speakers_Table_Actions_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Действия`)
};

const es_speakers_table_actions_header = /** @type {(inputs: Speakers_Table_Actions_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comportamiento`)
};

const zh_cn2_speakers_table_actions_header = /** @type {(inputs: Speakers_Table_Actions_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行动`)
};

const ja_speakers_table_actions_header = /** @type {(inputs: Speakers_Table_Actions_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクション`)
};

const hi_speakers_table_actions_header = /** @type {(inputs: Speakers_Table_Actions_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्रवाई`)
};

const pt_pt2_speakers_table_actions_header = /** @type {(inputs: Speakers_Table_Actions_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ações`)
};

/**
* | output |
* | --- |
* | "Actions" |
*
* @param {Speakers_Table_Actions_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_table_actions_header = /** @type {((inputs?: Speakers_Table_Actions_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Table_Actions_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speakers_table_actions_header(inputs)
	if (locale === "de") return de_speakers_table_actions_header(inputs)
	if (locale === "it") return it_speakers_table_actions_header(inputs)
	if (locale === "ru") return ru_speakers_table_actions_header(inputs)
	if (locale === "es") return es_speakers_table_actions_header(inputs)
	if (locale === "zh-CN") return zh_cn2_speakers_table_actions_header(inputs)
	if (locale === "ja") return ja_speakers_table_actions_header(inputs)
	if (locale === "hi") return hi_speakers_table_actions_header(inputs)
	if (locale === "pt-PT") return pt_pt2_speakers_table_actions_header(inputs)
	return en_speakers_table_actions_header(inputs)
});